export default __webpack_public_path__ + "static/media/gallery_11.115527b9.jpg";